import { observer } from "mobx-react-lite";
import { Redirect } from "react-router-dom";
import React, { useState, useCallback } from "react";

import "./composition.scss";
import PageLayout from "../../_layout/PageLayout";
import { SubscriptionMenuItemsModel } from "../SubscriptionMenuItems";
import { translationService } from "../../../services/translation/TranslationService";
import { api } from "../../../services/api/ApiService";
import { OrganizationSubscriptionPlansStorageModel } from "../../../services/organization-subscription-plans/OrganizationSubscriptionPlansStorage";
import { ManageSubscriptions } from "../../../services/authorization/Permissions";
import { currentUserService } from "../../../services/user/CurrentUserStorage";
import { PromotionCodeField } from "./components/PromotionCodeField"
import { DataSection } from "../../../components/data-components/sections/DataSections";

export default observer(function BillingDetailsPage() {
  const [subscriptionMenuItems] = useState(() => SubscriptionMenuItemsModel.create({}, {}));
  const menuItems = {
    staticItems: subscriptionMenuItems.getStaticMenuItems(),
  };

  const [organizationSubscriptionPlansStorage] = useState(() =>
    OrganizationSubscriptionPlansStorageModel.create({ autoLoad: false }, { api })
  );

  const redirectToCustomerPortalSessionURL = useCallback(async () => {
    const sessionUrl = await organizationSubscriptionPlansStorage.getCustomerPortalSessionUrl();
    window.location.href = sessionUrl;
  }, [organizationSubscriptionPlansStorage]);

  if (!currentUserService.currentUser.currentOrganization.hasPaidSubscription)
    return <Redirect to="/404" />;

  return (
    <PageLayout
      accessWithOneOfThePermissions={[ManageSubscriptions]}
      id="view-billing-details"
      titleKey="BillingDetails.page.title"
      menuItems={menuItems}
    >
      <DataSection labelKey="BillingDetails.payment.title">
        <div className="billing-details-payment">
          {translationService.translate("SubscriptionPlans.customer-portal-session-part1")}
          <u className="link" onClick={redirectToCustomerPortalSessionURL}>
            {translationService.translate("SubscriptionPlans.customer-portal-session-part2")}
          </u>
          {translationService.translate("SubscriptionPlans.customer-portal-session-part3")}
        </div>
      </DataSection>
      <DataSection labelKey="BillingDetails.promotion.title">
        <div className="billing-details-promotion">
          <PromotionCodeField />
        </div>
      </DataSection>
    </PageLayout>
  );
});
